import React from 'react';

const GroceryItemCard = ({ item }) => {
  const {
    name,
    image,
    final_price,
    unit_price,
    currency_code,
    restroType,
    avgRating,
    estimated_delivery_time,
    description,
  } = item;

  // Fallback for missing fields
  const price = final_price || unit_price || 0;
  const currency = currency_code || '₹';
  const rating = avgRating || (Math.random() * 2 + 3).toFixed(1); // dummy if missing

  return (
    <div className="w-full bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-200">
      <div className="relative h-48 overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/300x200?text=No+Image';
          }}
        />
        {restroType && (
          <span className="absolute top-2 left-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
            {restroType}
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-lg truncate">{name}</h3>
        <div className="flex items-center justify-between mt-2">
          <span className="text-sm text-gray-600">
            {rating} ⭐
          </span>
          {estimated_delivery_time && (
            <span className="text-sm text-gray-500">
              {estimated_delivery_time} min
            </span>
          )}
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="font-bold text-primary text-lg">
            {currency} {price.toFixed(2)}
          </span>
          <button className="bg-primary text-white px-4 py-1 rounded-full text-sm hover:bg-primary-dark transition-colors">
            Add
          </button>
        </div>
        {description && (
          <p className="mt-2 text-xs text-gray-500 line-clamp-2">{description}</p>
        )}
      </div>
    </div>
  );
};

export default GroceryItemCard;